import React, { useCallback, useEffect, useRef, memo, useMemo } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import connectOptions, { mergeProps } from '../../../utils/connectOptions';
import { verifyEmail, clearVerifiedEmail } from '../../../actions/verifyEmail';
import { Spinner } from '../Spinner';
import Button from '../Button';

import style from './style.module.css';

const EmailVerificationInput = ({
  id,
  isLoading,
  label,
  values,
  status,
  showLabel = false,
  inputRef: inputRefProp,
  onBlur,
  verifyEmail,
  clearVerifiedEmail,
  ...extraProps
}) => {
  const inputRef = useRef(null);

  useEffect(
    () => () => {
      clearVerifiedEmail();
    },
    [clearVerifiedEmail],
  );

  const handleInputRef = useCallback(
    input => {
      inputRef.current = input;
      if (inputRefProp) {
        inputRefProp(input);
      }
    },
    [inputRefProp],
  );

  const handleBlur = useCallback(
    (...rest) => {
      if (onBlur) return onBlur(...rest);
    },
    [onBlur],
  );

  const handleVerify = useCallback(() => {
    verifyEmail(inputRef.current.value);
  }, [verifyEmail]);

  const statusEmail = useMemo(() => {
    if (status === 'valid') {
      return <span className={classNames(style.iconVerify, 'fa fa-check')} />;
    }

    if (status === 'invalid') {
      return <span className={classNames(style.iconVerify, 'fa fa-close')} />;
    }

    return null;
  }, [status]);

  return (
    <div className={style.host}>
      <label className={classNames({ hidden: !showLabel })} htmlFor={id}>
        {label}
      </label>
      <div className="input-group">
        <input {...extraProps} {...values} ref={handleInputRef} autoComplete="off" onBlur={handleBlur} />
        {statusEmail}
        <span className="input-group-btn">
          <Button disabled={isLoading} onClick={handleVerify}>
            {isLoading ? (
              <Spinner className="email-verify-spinner" size="small" />
            ) : (
              <i className="fa fa-search mr0" title="Verify Email" />
            )}
          </Button>
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  status: state.verifyEmail.get('status'),
  isLoading: state.verifyEmail.get('loading'),
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      verifyEmail,
      clearVerifiedEmail,
    },
    dispatch,
  ),
});

const ConnectedEmailVerification = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
  connectOptions,
)(memo(EmailVerificationInput));

export { ConnectedEmailVerification };
export default ConnectedEmailVerification;
